export default __webpack_public_path__ + "static/media/p3.18502163.jpeg";